import { RouteRecordRaw, createRouter, createWebHistory } from 'vue-router'

import DeclineSuccess from '@/pages/DeclineSuccess.vue'
import Document from '@/pages/Document.vue'
import DocumentPreviewer from '@/pages/DocumentPreViewer.vue'
import ErrorPage from '@/pages/ErrorPage.vue'
import InvalidErrorPage from '@/pages/InvalidErrorPage.vue'
import PaymentSuccess from '@/pages/PaymentSuccess.vue'
import PdfViewer from '@/pages/PdfViewer.vue'
import PublicDocumentForm from '@/pages/PublicDocumentForm.vue'

const routes: Readonly<RouteRecordRaw[]> = [
  {
    path: '/documents/v1/status/:referenceId',
    component: PaymentSuccess,
    name: 'status-success',
    props: () => ({ isDocumentViewer: true }),
    end: true,
    strict: true,
  },
  {
    path: '/documents/decline-success/:documentId',
    component: DeclineSuccess,
    name: 'decline-success',
    props: true,
  },
  {
    path: '/documents/:documentId/:recipientId',
    component: Document,
    name: 'document',
    props: () => ({ isDocumentViewer: true }),
  },
  {
    path: '/documents/v1/:referenceId',
    component: Document,
    name: 'document-v1',
    props: () => ({ isDocumentViewer: true }),
  },
  // For backward compatibility with old preview route which has been discontinued
  {
    path: '/documents/preview/:documentId',
    component: InvalidErrorPage,
    name: 'document-preview-error',
    props: () => ({ isPreview: true }),
  },
  {
    path: '/v2/location/:locationId/payments/proposals-estimates/edit/preview/:documentId',
    component: DocumentPreviewer,
    name: 'proposals-estimates-preview',
    props: () => ({ isPreview: true }),
  },
  // Preview route for mobile that uses mobile token from local storage
  {
    path: '/document/mobile-preview/:documentId',
    component: DocumentPreviewer,
    name: 'document-mobile-preview',
    props: () => ({ isPreview: true, isMobilePreview: true }),
  },
  {
    path: '/documents/error/:type',
    component: ErrorPage,
    name: 'document-error',
    props: true,
  },
  {
    path: '/documents/pdf-viewer/:documentId',
    component: PdfViewer,
    name: 'pdf-viewer',
    props: () => ({ isPreview: false, isPDFView: true }),
  },
  {
    path: '/documents/doc-form/:documentId',
    component: PublicDocumentForm,
    name: 'public-document-form',
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

export { router }
